export enum MatriculaLMSEnum {
    Matriculado = 'MATRICULADO',
    NaoMatriculado = 'NAO_MATRICULADO',
}
